module.exports = __webpack_public_path__ + "static/media/team-caroline.14f76af9.jpg";